import axios from '@/common/axios'
import qs from 'qs'

export function addVisitLimit (data) {
  return axios({
    method: 'post',
    url: '/visitLimit/add',
    data: qs.stringify(data)
  })
}

export function updateVisitLimit (data) {
  return axios({
    method: 'put',
    url: '/visitLimit/update',
    data: qs.stringify(data)
  })
}

export function selectByUserId (params) {
  return axios({
    method: 'get',
    url: '/visitLimit/selectByUserId',
    params
  })
}

export function updateStatusNoStop (params) {
  return axios({
    method: 'put',
    url: '/visitLimit/updateStatusNoStop',
    params
  })
}

export function selectOneStatus (params) {
  return axios({
    method: 'get',
    url: '/visitLimit/selectOneStatus',
    params
  })
}

export function getIdByTimeListForWeb (appointment) {
  return axios({
    method: 'get',
    url: '/visitLimit/getIdByTimeListForWeb/' + appointment
  })
}

export function selectByIdVisitLimit (id) {
  return axios({
    method: 'get',
    url: '/visitLimit/selectByIdVisitLimit/' + id
  })
}

export function existStartTime (params) {
  return axios({
    method: 'get',
    url: '/visitLimit/existStartTime',
    params
  })
}

export function canInsert (params) {
  return axios({
    method: 'get',
    url: '/visitLimit/canInsert',
    params
  })
}

export function selectInDate (params) {
  return axios({
    method: 'get',
    url: '/visitLimit/selectInDate',
    params
  })
}

export function exists (data) {
  return axios({
    method: 'post',
    url: '/visitLimit/exists',
    data: qs.stringify(data)
  })
}

export function updateStatusForOne (id) {
  return axios({
    method: 'put',
    url: '/visitLimit/updateStatusForOne/' + id
  })
}










